import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

// NewProduct page components
import FormField from "layouts/ecommerce/products/new-product/components/FormField";
import MDEditor from "../../../../../../components/MDEditor";
import Switch from "@mui/material/Switch";

const minimumDayOptions = Array.from({ length: 11 }, (_, day) => String(day));
const displayDayOptions = Array.from({ length: 10 }, (_, day) => String(day + 1));
const openingDayOptions = Array.from({ length: 11 }, (_, day) => String(day));

function AmenityTiming({validStep, uniqueId, oldValues, valueSetter, ...rest}) {
  const sameDayBooking =
    typeof oldValues.same_day_booking === "boolean"
      ? oldValues.same_day_booking
      : String(oldValues.same_day_booking).toLowerCase() === "true";
  const minimumDaysValue = sameDayBooking
    ? "0"
    : oldValues.advanced_day === "0"
      ? "1"
      : oldValues.advanced_day || "1";
  const setMinimumDays = (day) => {
    if (!minimumDayOptions.includes(day)) return;
    valueSetter({ ...oldValues, advanced_day: day, same_day_booking: day === "0" });
  };
  const setDisplayDays = (day) => {
    if (displayDayOptions.includes(day)) valueSetter({ ...oldValues, days_a_head: day });
  };
  const setOpeningDays = (day) => {
    if (openingDayOptions.includes(day)) valueSetter({ ...oldValues, booking_open_days_before: day });
  };

  return (
    <MDBox>
      <MDTypography variant="h5">Amenity Timing</MDTypography>
      <MDBox mt={2}>
        <Grid container spacing={3}>
          {/*<Grid item xs={12} sm={6}>*/}
          {/*    <FormField type="date" label="Start At"  value={"2022-10-10"} />*/}
          {/*</Grid>*/}
          {/*<Grid item xs={12} sm={6}>*/}
          {/*    <FormField type="date" label="Expire At" value={"2999-12-29"} />*/}
          {/*</Grid>*/}
          <Grid item xs={12} sm={4}>
              <Autocomplete
                  disableClearable
                  autoHighlight
                  autoSelect
                  value={minimumDaysValue}
                  getOptionLabel={option => option.toString()}
                  options={minimumDayOptions}
                  // renderInput={(params) => (
                  //   <FormField {...params} InputLabelProps={{ shrink: true }}  label={"Day Of Booking Advanced"}/>
                  // )}
                  renderInput={(params) => (
                    <FormField {...params} InputLabelProps={{ shrink: true }}  label={"Minimum days before booking"}/>
                  )}
                  onChange={(e, data) => setMinimumDays(data)}
                  onInputChange={(e, input, reason) => {
                    if (reason === "input") setMinimumDays(input);
                  }}
                />
          </Grid>
          <Grid item xs={12} sm={4}>
              <Autocomplete
                  disableClearable
                  autoHighlight
                  autoSelect
                  value={oldValues.days_a_head?.toString() || "1"}
                  options={displayDayOptions}
                  renderInput={(params) => (
                    <FormField {...params} InputLabelProps={{ shrink: true }}  label={"Number of days ahead (shown)"}/>
                  )}
                  onChange={(e, data) => setDisplayDays(data)}
                  onInputChange={(e, input, reason) => {
                    if (reason === "input") setDisplayDays(input);
                  }}
                />
          </Grid> 
          <Grid item xs={12} sm={4}>
            <Autocomplete
              disableClearable
              autoHighlight
              autoSelect
              value={oldValues.booking_open_days_before?.toString() ?? "3"}
              options={openingDayOptions}
              renderInput={(params) => (
                <FormField {...params} InputLabelProps={{ shrink: true }} label="Open each date this many days before" />
              )}
              onChange={(e, data) => setOpeningDays(data)}
              onInputChange={(e, input, reason) => {
                if (reason === "input") setOpeningDays(input);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormField
              type="time"
              label="Daily opening time (Toronto time)"
              InputLabelProps={{ shrink: true }}
              value={oldValues.booking_open_time ?? "18:00"}
              onChange={(e) => valueSetter({ ...oldValues, booking_open_time: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormField
              type="number"
              label={oldValues.booking_limit_group_name ? "Group: maximum future bookings per unit" : "Maximum future bookings per unit"}
              disabled={Boolean(oldValues.booking_limit_group_id)}
              InputProps={{ inputProps: { min: 1, max: 255 } }}
              InputLabelProps={{ shrink: true }}
              value={oldValues.max_future_bookings_per_unit ?? "3"}
              onChange={(e) => valueSetter({ ...oldValues, max_future_bookings_per_unit: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormField
              type="number"
              label={oldValues.booking_limit_group_name ? "Group: maximum daily bookings per person" : "Maximum daily bookings per person"}
              disabled={Boolean(oldValues.booking_limit_group_id)}
              InputProps={{ inputProps: { min: 1, max: 255 } }}
              InputLabelProps={{ shrink: true }}
              value={oldValues.max_daily_bookings_per_user ?? "2"}
              onChange={(e) => valueSetter({ ...oldValues, max_daily_bookings_per_user: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <MDTypography variant="caption" color="text">
              Each date opens separately at the selected Toronto time. The opening lead must be at least the minimum days before booking.
            </MDTypography>
            {oldValues.booking_limit_group_name && <MDTypography display="block" variant="caption" color="text">
              These limits belong to the “{oldValues.booking_limit_group_name}” group and are set when the group is created.
            </MDTypography>}
          </Grid>
          <Grid item xs={12} sm={3}>

              <Switch
                title={"Hello"}
                size={"medium"}
                checked={sameDayBooking}
                onChange={(e, x) =>
                  valueSetter({
                    ...oldValues,
                    same_day_booking: x,
                    advanced_day: x ? "0" : oldValues.advanced_day === "0" ? "1" : oldValues.advanced_day,
                  })
                }
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Same day booking
              </MDTypography>

          </Grid>
          {/*<Grid item xs={12} sm={3}>*/}

          {/*    <Switch title={"Hello"} size={"medium"} />*/}
          {/*    <MDTypography*/}
          {/*      variant="button"*/}
          {/*      fontWeight="regular"*/}
          {/*      color="text"*/}
          {/*      sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}*/}
          {/*    >*/}
          {/*      &nbsp;&nbsp;Last day booking*/}
          {/*    </MDTypography>*/}

          {/*</Grid>*/}
        </Grid>
      </MDBox>
    </MDBox>
  );
}


export default AmenityTiming;
